import React, { useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IconCircleMinus } from "@tabler/icons-react";
import { LangConstant } from "const";

const UserTable = ({ users, selectedUsers = [], onActionClick, actionType, loadMore, hasMore, onSelected }) => {
  const observer = useRef(null);
  const { t: getLabel } = useTranslation();
  const lastUserRef = useCallback(
    node => {
      if (!node || !hasMore) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            loadMore();
          }
        },
        { threshold: 1.0 },
      );

      observer.current.observe(node);
    },
    [hasMore, loadMore],
  );

  return (
    <div style={{ flex: 1 }}>
      <div className="table-responsive" style={{ maxHeight: 550, overflowY: "auto" }}>
        <table className="table table-vcenter" style={{ minWidth: 650 }}>
          <thead>
            <tr>
              <th style={{ width: "5%", fontWeight: "bold" }} className="text-center">
                {actionType === "add" && getLabel("TXT_STT")}
              </th>
              <th style={{ width: "25%", fontWeight: "bold" }}>
                {getLabel("TXT_FULL_NAME")}
              </th>
              <th style={{ width: "13%", fontWeight: "bold" }}>
                {getLabel("TXT_PHONENUMBER")}
              </th>
              <th style={{ width: "13%", fontWeight: "bold" }}>
                {getLabel("TXT_UNIT")}
              </th>
              <th style={{ width: "13%", fontWeight: "bold" }}>
                {getLabel("TXT_DEPARTMENT")}
              </th>
              <th style={{ width: "13%", fontWeight: "bold" }}>
                {getLabel("TXT_POSITION")}
              </th>
              <th style={{ width: "5%", fontWeight: "bold" }} className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              users.map((user, index) => (
                <tr key={user.id} ref={index === users.length - 1 ? lastUserRef : null}>
                  <td className="text-center">
                    {actionType === "remove" ? (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectedUsers.some(selected => selected.id === user.id)}
                        onChange={() => onSelected(user)}
                        style={{ width: 24, height: 24 }}
                      />
                    ) : (
                      index + 1
                    )}
                  </td>
                  <td>{user.name}</td>
                  <td>{user.phone || getLabel(LangConstant.TXT_NOT_FOUND)}</td>
                  <td>{user.unitName || getLabel(LangConstant.TXT_NOT_FOUND)}</td>
                  <td>{user.departmentName || getLabel(LangConstant.TXT_NOT_FOUND)}</td>
                  <td>{user.positionName || getLabel(LangConstant.TXT_NOT_FOUND)}</td>
                  <td className="text-center">
                    {actionType === "add" ? (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ width: 24, height: 24 }}
                        onChange={() => onActionClick(user)}
                        checked={selectedUsers.some(selected => selected.id === user.id)}
                      />
                    ) : (
                      <button
                        className="btn btn-icon btn-ghost-danger btn-sm"
                        onClick={() => onActionClick(user)}
                        title={getLabel(LangConstant.TXT_REMOVE_MEMBER)}
                        style={{ width: 24, height: 24 }}
                      >
                        <IconCircleMinus size={16} />
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  <i>{getLabel("TXT_DATA_NOT_FOUND")}</i>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;
